import type {Component} from 'typings/portaro.fe.types';
import {ngAsync} from 'shared/utils/ng-@decorators';
import type SimilarDocumentsDataService from '../../data-services/similar-documents.data-service';
import type {IOnInit} from 'angular';
import type {RichDocument} from 'typings/portaro.be.types';


interface KpSimilarDocumentsComponentBindings {
    recordId: string;
}

/**
 * @ngdoc component
 * @name kpSimilarDocuments
 * @module portaro.components.kp-similar-documents
 *
 * @param {string} recordId unique record id
 *
 * @description
 * Component collects list of similar documents to document which is actually edited
 */
export default class KpSimilarDocumentsComponent implements Component<KpSimilarDocumentsComponentBindings> {
    public static componentName = 'kpSimilarDocuments';

    public templateUrl = require('./kp-similar-documents.tpl.ftl');

    public bindings = {
        recordId: '<'
    } as const;

    public controller = KpSimilarDocumentsComponentController;
}

class KpSimilarDocumentsComponentController implements KpSimilarDocumentsComponentBindings, IOnInit {
    public recordId: string;
    public similarDocuments: RichDocument[];

    /*@ngInject*/
    protected constructor(private similarDocumentsDataService: SimilarDocumentsDataService) {
    }

    @ngAsync()
    public async $onInit() {
        this.similarDocuments = await this.similarDocumentsDataService.query(this.recordId);
    }
}
